import { Box } from "@mui/material";
import type { ColumnBarFill } from "../../utils/tableMappingBuilder";
import { computeBarFillLayout, type ColumnNumericRange } from "../../utils/tableBarFill";
import { formatColumnValue, type ColumnFormat } from "../../utils/columnFormat";

type Props = {
  value: unknown;
  display: string;
  barFill: ColumnBarFill;
  range: ColumnNumericRange | null;
  format?: ColumnFormat;
};

const DEFAULT_POSITIVE_COLOR = "#5470c6";
const DEFAULT_NEGATIVE_COLOR = "#ee6666";

export default function TableBarFillCell({ value, display, barFill, range, format }: Props) {
  const { positivePct, negativePct } = computeBarFillLayout(value, barFill, range);
  const showValue = barFill.showValue !== false;
  const positiveColor = barFill.color || DEFAULT_POSITIVE_COLOR;
  const negativeColor = barFill.color || DEFAULT_NEGATIVE_COLOR;
  const formatted =
    display ||
    (value != null && value !== "" ? formatColumnValue(value, format) : "");

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: 22,
        display: "flex",
        alignItems: "center",
      }}
    >
      {positivePct > 0 && (
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 2,
            bottom: 2,
            width: `${positivePct}%`,
            bgcolor: positiveColor,
            opacity: 0.35,
            borderRadius: 0.5,
          }}
        />
      )}
      {negativePct > 0 && (
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 2,
            bottom: 2,
            width: `${negativePct}%`,
            bgcolor: negativeColor,
            opacity: 0.35,
            borderRadius: 0.5,
          }}
        />
      )}
      {showValue && (
        <Box
          component="span"
          sx={{
            position: "relative",
            zIndex: 1,
            px: 0.5,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "100%",
          }}
        >
          {formatted || "—"}
        </Box>
      )}
    </Box>
  );
}
